import axios from 'axios';
import { axiosConfig } from '@/config/axiosConfig.js';
import { convert_ISO_datetime_str, get_datetime_obj } from '@/utils/common/custom_time.js'
import { call_case_monitor_table_ajax } from '@/utils/case/case.js';
import {
    no_data_error_texts,
    TABLE_VALUE_TEXT_MAPPING,
    alert_color_style_mapping,
    monitor_signs_normal_mapping_css,
    monitor_signs_icon_name_mapping,   
} from '@/config/monitor_config.js';

export function monitor_ajax(client_name, param = {}) {
    return axios.post(`${client_name}/rainmonitor/get_department_tag_list_layer/`, param, axiosConfig);
}

export function redirect_monitor_table_ajax(table_value) {
    const is_case_mode = this.$store.getters['case/is_case_mode'];
    if (is_case_mode) {
        // skip datetime
        return call_case_monitor_table_ajax.call(this, table_value)
    } 
    return monitor_table_datetime_ajax.call(this, table_value);
}

export async function monitor_table_datetime_ajax(table_value) {
    const client_name = this.$store.state.client_name;
    const group_name = this.$store.getters.group_name
    const tag_name = TABLE_VALUE_TEXT_MAPPING[table_value]['tag_name'];
    const param = {
        'tag_id': table_value,
        'group': group_name
    };
    const res = await axios.post(`${client_name}/rainmonitor/get_tag_sectiondisplay_data_time_by_tag/`, param, axiosConfig);
    if (!(res.data instanceof Object)) {
        res.data = JSON.parse(res.data);
    }

    if (res.data?.data?.length === 2) {
        const new_date = res.data.data[1].split(' ')[0];
        const new_time = res.data.data[1].split(' ')[1].slice(0, 5);

        if (this.date === new_date && this.time === new_time) {
            return;
        }

        this.date = new_date;
        this.time = new_time;

        monitor_table_ajax.call(this, table_value, res.data.data[1]);
    } else {
        this.error_text = no_data_error_texts[tag_name] ? no_data_error_texts[tag_name] : this.$t('__datatable.no_available_data_any_time_text')
        this.table_data = [];
    }
}

async function get_monitor_map(client_name, param) {
    const res = await axios.post(`${client_name}/rainmonitor/get_tag_reference_webmaps/`, param, axiosConfig);
    if (!(res.data instanceof Object)) {
        res.data = JSON.parse(res.data);
    }
    if (res.data.status === 'success') {
        try {
            this.$store.commit('emap-monitor/set_monitor_map', res.data.data);
        } catch (error) {
            console.error(error);
            this.error_text = '地圖資料讀取錯誤，請聯繫系統維護人員。';
        }
    } else {
        this.error_text = '地圖資料讀取錯誤，請聯繫系統維護人員。';
    }
}

export async function monitor_table_ajax(table_value, date_time) {
    const client_name = this.$store.state.client_name;
    const group_name = this.$store.getters.group_name
    const language = this.$store.state.language 
    const reference_map_list = Object.keys(this.$store.state.monitor.reference_map);
    // const tag_name = TABLE_VALUE_TEXT_MAPPING[table_value]['tag_name'];
    const param = {
        tag_id: table_value,
        data_time: date_time,
        group: group_name,
        lang: language,
        case_id: this.$store.state.case.case_selected.case_id,
    };

    if (reference_map_list.includes(`${table_value}`)) {
        const param = {
            tag_id: table_value,
            data_time: date_time
        };
        get_monitor_map.call(this, client_name, param);
    }

    const res = await axios.post(`${client_name}/rainmonitor/get_tag_sectiondisplay_by_tag/`, param, axiosConfig);
    if (!(res.data instanceof Object)) {
        res.data = JSON.parse(res.data);
    }
    if (res.data.status === 'success') {
        try {
            if (this.$store.state.monitor.is_custom_monitor) {
                this.generate_table_data(res.data.data)
            } else {
                sort_monitor_table_page_data.call(this, res.data.data, table_value, language);
            }
            
            this.error_text = '';
        } catch (error) {
            console.error(error);
            this.error_text = '資料讀取錯誤，請聯繫系統維護人員。';
        }
    } else if ((res.data.failed_code ?? '').includes('json file not exists')) {
        this.error_text =  this.$t('__datatable.no_available_data_in_time_text')
        this.table_data = [];
        this.header = [];
    } else {
        this.error_text =  this.$t('__datatable.backend_response_fail_text')
        this.table_data = [];
        this.header = [];
    }
}

export function sort_monitor_table_page_data(data, table_value, language='tw') {
    let table_header_name 
    table_header_name = TABLE_VALUE_TEXT_MAPPING[table_value]['title'];
    if (language === 'en') {
        table_header_name = TABLE_VALUE_TEXT_MAPPING[table_value]['title_en'];
    }
    
    const sorted_header_list = table_header_name.map((name, index) => {
        return {
            'text': name,
            'value': name,
            'order': index,
            'align': 'center',
        };
    });
    this.generate_table_data(data, sorted_header_list);
}

export function station_history_ajax(station_code, data_time, data_type) {
    const client_name = this.$store.state.client_name;
    const lang = this.$store.state.language 
    const param = {
        station_code,
        data_time,
        lang,
        data_type,
    };
    return axios.post(`${client_name}/rainmonitor/get_station_history_data/`, param, axiosConfig)
        .then((res) => {
            if (!(res.data instanceof Object)) {
                res.data = JSON.parse(res.data);
            }
            if (res.data.status === 'success') {
                this.history_data = res.data.data;
                this.history_data_loaded = true;
            } else {
                this.history_data = {};
                this.history_data_loaded = true;
            }
        })
        .catch((error) => {
            console.error(error);
        });
}

export function weather_station_history_data(station_code, data_time) {
    const client_name = this.$store.state.client_name;
    const lang = this.$store.state.language 
    const param = {
        station_code,
        data_time,
        lang,
    };
    return axios.post(`${client_name}/rainmonitor/get_weather_station_history_data/`, param, axiosConfig)
        .then((res) => {
            if (!(res.data instanceof Object)) {
                res.data = JSON.parse(res.data);
            }
            if (res.data.status === 'success') {
                this.history_data = res.data.data;
                this.history_data_loaded = true;
            } else {
                this.history_data = {};
                this.history_data_loaded = true;
            }
        })
        .catch((error) => {
            console.error(error);
        });
}

export function reconstruct_monitor_data(data) {
    const all_layers = [];
    const sublayers = {};
    const node_keys = Object.keys(data);

    node_keys.forEach((node_key) => {
        // 要用 $set initial 物件，最後在 assign 值進去
        this.$set(this.init_radios, node_key, []);
        sublayers[node_key] = [];

        let first_layers = {
            'name': node_key,
            'node': true,
            'layer1': true,
            'icon': '',
            'radio_name': node_key + '_root',
            'children': []
        };

        data[node_key].forEach((second_layer) => {
            let second_layer_item;
            const second_layer_name = second_layer['text'];
            if (second_layer['children']) {
                second_layer_item = {
                    'name': second_layer_name,
                    'node': true,
                    'layer1': false,
                    'icon': '',
                    'radio_name': node_key,
                    'children': [],
                    'index': first_layers['children'].length
                };
                this.$set(this.init_radios, second_layer_name, []);
                sublayers[node_key].push(true);
                sublayers[second_layer_name] = [];
                node_keys.push(second_layer_name);

                second_layer['children'].forEach((third_layer) => {
                    const third_layer_item = {
                        'name': third_layer['text'],
                        'node': false,
                        'type': 'cross_type_single_radio',
                        'layer1': false,
                        'icon': '',
                        'radio_name': `${second_layer_name}`,
                        'index': second_layer_item['children'].length,
                    };
                    second_layer_item['children'].push(third_layer_item);
                    sublayers[second_layer_name].push(third_layer['text'] === this.default_name);
                });
            } else {
                second_layer_item = {
                    'name': second_layer_name,
                    'node': false,
                    'type': 'cross_type_single_radio',
                    'layer1': false,
                    'icon': '',
                    'radio_name': node_key,
                    'index': first_layers['children'].length,
                };
                sublayers[node_key].push(second_layer_name === this.default_name);
            }
            first_layers['children'].push(second_layer_item);
        });

        all_layers.push(first_layers);
    });
    this.init_items.push.apply(this.init_items, all_layers);
    this.init_opened_layers.push.apply(this.init_opened_layers, node_keys);

    this.init_radios = Object.assign({}, this.init_radios, sublayers);
}



export async function monitor_document_ajax(monitor_type) {
    const client_name = this.$store.state.client_name;
    const group_name = this.$store.getters.group_name
    const param = {
        tag_id: monitor_type,
        group: group_name,
        case_id: this.$store.state.case.case_selected.case_id,
    };
    
    const res = await axios.post(`${client_name}/rainmonitor/get_tag_document_link/`, param, axiosConfig)
    try {
        if (!(res.data instanceof Object)) {
            res.data = JSON.parse(res.data);
        }
        if (!res.data.failed_code) {
            open(res.data.data);
        } else {
            alert('說明文件有問題或不存在，請聯繫系統維護人員');
        }
    } catch (error) {
        console.error(error);
    }
}

export async function get_multiple_table_newest_datetime(table_value_list) {
    const client_name = this.$store.state.client_name;
    const group_name = this.$store.getters.group_name

    const requests = table_value_list.map(table_value => {
        const tag_name = TABLE_VALUE_TEXT_MAPPING[table_value]['tag_name'];
        const param = {
            tag_name,
            'group': group_name
        };

        return axios.post(`${client_name}/rainmonitor/get_tag_sectiondisplay_data_time_by_tag/`, param, axiosConfig);
    })
    
    const responses = await Promise.all(requests)
    const newest_datetime = responses
        .map(response => new Date(convert_ISO_datetime_str(response.data.data[1])))
        .reduce((common_newest_time, time) => time < common_newest_time ? time : common_newest_time)

    const {yyyy, mm, dd, HH, MM} = get_datetime_obj(newest_datetime)
    return `${yyyy}-${mm}-${dd}T${HH}:${MM}`.split('T')
}

export function reconstruct_alert_content(table_data) {
    return table_data.reduce((accumulator, datum) => {
        if (!datum['警示']) return accumulator

        const item_num = datum['項次'] || datum['編號']
        const alert_value = datum['警示']
        const alert_color = alert_color_style_mapping[alert_value]
        const signal_class = monitor_signs_normal_mapping_css[alert_value]
        const icon_class = monitor_signs_icon_name_mapping[alert_value]

        // 為了保留最嚴重燈號，當新的alert_color比之前嚴重時才去改 accumulator 裡 [item_num] 內容
        if (
            !accumulator[item_num] ||
            (alert_color == '#ff0000' && ['#ffff00', '#ff9900', '#00ff00'].includes(accumulator[item_num].color)) ||
            (alert_color == '#ff9900' && ['#ffff00'].includes(accumulator[item_num].color))
        ) {
            return {
                ...accumulator,
                [item_num]: {
                    color: alert_color,
                    icon_class,
                    signal_class
                }
            }
        } else {
            return {...accumulator}
        }

    }, {})
}

export async function history_light_warning_ajax(id, start_time, end_time) {
    const client_name = this.$store.state.client_name //目前只適用於THB|TRA相關表格
    const param = {
        tag_id: id,
        start_time: start_time,
        end_time: end_time

    }
    const res = await axios.post(
        `/${client_name}/rainmonitor/get_history_light_warning/`,
        param,
        axiosConfig
    )

    try {
        return (!(res.data instanceof Object)) ? JSON.parse(res.data) : res.data;
    } catch (error) {
        console.error(error);
        this.error_text = '資料讀取錯誤，請聯繫系統維護人員。';
    }
}